export default function BattleArena() {
  return (
    <section className="relative py-20 px-4 z-10 min-h-screen">
      <div className="max-w-5xl mx-auto">
        <div className="mb-16 pt-16 text-center">
          {/* Logo Header */}
          <div className="mb-12 flex justify-center">
            <img
              src="https://static.lumi.new/5d/5d0152a29be0629746bafaa50ddd683a.webp"
              alt="Battle Arena"
              className="w-full max-w-2xl h-auto"
            />
          </div>

          {/* Beta Live Alert */}
          <div className="mb-8 flex justify-center">
            <div className="inline-flex items-center gap-3 px-6 py-2 bg-purple-500/20 border-2 border-purple-400 rounded-full text-purple-300 font-bold text-lg shadow-[0_0_30px_rgba(168,85,247,0.5)] animate-pulse">
              <span className="text-xl">⚔️</span>
              BETA IS LIVE!
              <span className="text-xl">⚔️</span>
            </div>
          </div>

          {/* Enter Arena Button */}
          <div className="mb-12 flex justify-center">
            <a
              href="https://battle.MandoxToken.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-black border-2 border-cyan-400 text-white font-bold text-lg rounded-lg hover:bg-cyan-400/20 hover:shadow-[0_0_30px_rgba(34,211,238,0.6)] transition-all duration-300"
            >
              <span className="text-2xl">⚔️</span>
              Enter the Arena
              <span className="text-2xl">⚔️</span>
            </a>
          </div>

          {/* Description */}
          <div className="max-w-4xl mx-auto text-left px-4">
            <p className="text-base md:text-lg text-white/80 leading-relaxed">
              Mandox NFT Battle Arena is a competitive 1v1 card battle game where your Mandox NFT collections on Ethereum transform into powerful battle cards. Each NFT's unique traits determine its combat stats and rarity-based strength. Connect your wallet, select up to 3 fighters from your collection, and face off against other players in strategic turn-based battles. Climb the global leaderboard by winning matches, showcase your prowess in the community chatroom, and prove you're the ultimate Mandox champion. The beta is now live – enter the arena and dominate!
            </p>
          </div>

          {/* Arena Image */}
          <div className="mt-12 flex justify-center">
            <img
              src="https://static.lumi.new/4b/4b0ee6db211fcd3915545770b6819d44.webp"
              alt="Battle Arena"
              className="w-full max-w-5xl h-auto rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
